'use client';

import { forwardRef, type ReactNode } from 'react';
import { Button, type SxProps, type Theme } from '@mui/material';

interface SportsFilterButtonProps {
  label: ReactNode;
  isActive: boolean;
  onClick: () => void;
  startIcon?: ReactNode;
  variant?: 'contained' | 'outlined' | 'text';
  sx?: SxProps<Theme>;
}

/**
 * Reusable filter button for the sports page (Live/Futures toggle)
 */
export const SportsFilterButton = forwardRef<HTMLButtonElement, SportsFilterButtonProps>(
  ({ label, isActive, onClick, startIcon, variant = 'outlined', sx }, ref) => {
    return (
      <Button
        ref={ref}
        variant={variant}
        onClick={onClick}
        startIcon={startIcon}
        sx={{
          textTransform: 'none',
          fontSize: '0.875rem',
          fontWeight: 600,
          py: 1,
          borderRadius: '0.5rem',
          bgcolor: isActive ? 'action.selected' : 'transparent',
          border: '1px solid',
          borderColor: isActive ? 'primary.main' : 'divider',
          color: isActive ? 'primary.main' : 'text.primary',
          '&:hover': {
            bgcolor: isActive ? 'action.hover' : 'action.hover',
            borderColor: isActive ? 'primary.main' : 'divider',
          },
          ...sx,
        }}
      >
        {label}
      </Button>
    );
  }
);

SportsFilterButton.displayName = 'SportsFilterButton';
